<template lang='pug'>
  v-col(sm='12')
    v-row(no-gutters)
      v-col(style='padding: 0 20px')
        md-card
          md-card-header.md-card-header-icon.md-card-header-green
            .card-icon
              md-icon settings
            h4.title
              | {{ $t("webChannel.Auth.title") }}
          md-card-content
            form.form-horizontal(action method='post')
              .md-layout
                .md-layout-item(style='margin: auto;')
                  | {{
                  | $t(
                  | "webChannel.Auth.subitems.enableUserRatings"
                  | )
                  | }}
                .md-layout-item.md-form-label.md-size-15(style='padding: 0; margin: auto;' :class="{\
                'text-success': isGovAuthEnable,\
                'text-danger': !isGovAuthEnable\
                }")
                  | {{
                  | isGovAuthEnable
                  | ? $t("commonWords.enabled")
                  | : $t("commonWords.disabled")
                  | }}
                .md-layout-item.md-size-15
                  md-switch(v-model='isGovAuthEnable')

              .md-layout
                .md-layout-item(style='margin: auto; margin-left: 15px;')
                  | {{
                  | $t(
                  | "webChannel.Auth.subitems.enableUserRatingsNotLogged"
                  | )
                  | }}
                .md-layout-item.md-form-label.md-size-15(style='padding: 0; margin: auto;' :class="{\
                'text-success': canalWebData.isGovAuthEnableNotLogged,\
                'text-danger': !canalWebData.isGovAuthEnableNotLogged\
                }")
                  | {{
                  | canalWebData.isGovAuthEnableNotLogged
                  | ? $t("commonWords.enabled")
                  | : $t("commonWords.disabled")
                  | }}
                .md-layout-item.md-size-15(:class='!isGovAuthEnable?"govBr":"govBr2"')
                  md-switch(v-model='canalWebData.isGovAuthEnableNotLogged' :disabled='!isGovAuthEnable')
              .md-layout
                .md-layout-item(style='margin: auto; margin-left: 15px;')
                  | {{
                  | $t(
                  | "webChannel.Auth.subitems.enableUserRatingsLogged"
                  | )
                  | }}
                .md-layout-item.md-form-label.md-size-15(style='padding: 0; margin: auto; margin-left:15px;' :class="{\
                'text-success': canalWebData.isGovAuthEnableLogged,\
                'text-danger': !canalWebData.isGovAuthEnableLogged\
                }" id='govBr1')
                  | {{
                  | canalWebData.isGovAuthEnableLogged
                  | ? $t("commonWords.enabled")
                  | : $t("commonWords.disabled")
                  | }}
                .md-layout-item.md-size-15(:class='!isGovAuthEnable?"govBr":"govBr2"')
                  md-switch(v-model='canalWebData.isGovAuthEnableLogged' :disabled='!isGovAuthEnable')
              .md-layout
                .md-layout-item(style='margin: auto; margin-left: 15px;')
                  | {{
                  | $t(
                  | "webChannel.Auth.subitems.logoutGovBrPermition"
                  | )
                  | }}
                .md-layout-item.md-form-label.md-size-15(style='padding: 0; margin: auto; margin-left:15px;' :class="{\
                'text-success': canalWebData.isGovAuthEnableLogout,\
                'text-danger': !canalWebData.isGovAuthEnableLogout\
                }" id='govBr1')
                  | {{
                  | canalWebData.isGovAuthEnableLogout
                  | ? $t("commonWords.enabled")
                  | : $t("commonWords.disabled")
                  | }}
                .md-layout-item.md-size-15(:class='!isGovAuthEnable?"govBr":"govBr2"')
                  md-switch(v-model='canalWebData.isGovAuthEnableLogout' :disabled='!isGovAuthEnable')
              .md-layout
                .md-layout-item.md-size-50(style='padding-left: 0')
                md-field(style='margin-top: 30px;')
                  label
                    | {{
                    | $t(
                    | "webChannel.Auth.subitems.govbrText"
                    | )
                    | }}
                  md-input(v-model='canalWebData.govbrText')
                .md-layout-item.md-size-50(style='padding-left: 0')
                md-field(style='margin-top: 30px;')
                  label
                    | {{
                    | $t(
                    | "webChannel.Auth.subitems.presentationAuth"
                    | )
                    | }}
                  md-input(v-model='canalWebData.presentationAuth')

                .md-layout-item.md-size-50(style='padding-left: 0')
                md-field(style='margin-top: 30px;')
                  label
                    | {{
                    | $t(
                    | "webChannel.Auth.subitems.welcomeTextLogin"
                    | )
                    | }}
                  md-textarea(v-model='canalWebData.welcomeTextLogin' md-autogrow)
                md-field(style='margin-top: 30px;')
                  label
                    | {{
                    | $t(
                    | "webChannel.Auth.subitems.loggedMessage"
                    | )
                    | }}
                  md-textarea(v-model='canalWebData.loggedMessage' md-autogrow)

                md-field(style='margin-top: 30px;')
                  label
                    | {{
                    | $t(
                    | "webChannel.Auth.subitems.errorLogin"
                    | )
                    | }}
                  md-textarea(v-model='canalWebData.errorLogin' md-autogrow)
                md-field(style='margin-top: 30px;')
                  label
                    | {{
                    | $t(
                    | "webChannel.Auth.subitems.reliabilitysInvalid"
                    | )
                    | }}
                  md-textarea(v-model='canalWebData.reliabilitysInvalid' md-autogrow)
                md-content(md-theme="selection-black")
                  p.warning-text
                    | {{$t('govBrAuth.theSettingsBelowAffecTheGovbrAuthenticationService')}}
                md-content
                md-field(style='margin-top: 30px;')
                  label
                    | {{
                    | $t(
                    | "webChannel.Auth.subitems.redirectUri"
                    | )
                    | }}
                  md-input(v-model='canalWebData.redirectUri')

                md-field(style='margin-top: 30px;')
                  label
                    | {{
                    | $t(
                    | "webChannel.Auth.subitems.clientId"
                    | )
                    | }}
                  md-input(v-model='canalWebData.clientId')
                md-field(style='margin-top: 30px;')
                  label
                    | {{
                    | $t(
                    | "webChannel.Auth.subitems.urlSso"
                    | )
                    | }}
                  md-input(v-model='canalWebData.urlSso')

                md-field(style='margin-top: 30px;')
                  label
                    | {{
                    | $t(
                    | "webChannel.Auth.subitems.responseType"
                    | )
                    | }}
                  md-input(v-model='canalWebData.responseType')
                md-field(style='margin-top: 30px')
                  label
                    | {{
                    | $t(
                    | "webChannel.Auth.subitems.reliabilitys"
                    | )
                    | }}
                  md-select(v-model='reliabilitiesTypes' multiple)
                    span(v-for='(label, i) in labels', :key='label')
                      md-option(:value='label') {{ label }}
</template>

<script>
export default {
  props: {
    canalWebData: {
      type: Object,
      required: true
    }
  },
  watch: {
    reliabilitiesTypes (nV) {
      this.canalWebData.reliabilitiesTypes = nV
    },
    isGovAuthEnable (newValue) {
      this.canalWebData.isGovAuthEnable = newValue
      if (!newValue) {
        this.canalWebData.isGovAuthEnableNotLogged = false
        this.canalWebData.isGovAuthEnableLogged = false
        this.canalWebData.isGovAuthEnableLogout = false
      }
    }
  },
  data () {
    return {
      reliabilitiesTypes: this.canalWebData.reliabilitiesTypes
        ? this.canalWebData.reliabilitiesTypes
        : [],
      labels: [
        'kba_previdencia',
        'cadastro_basico',
        'servidor_publico',
        'biovalid_facial',
        'balcao_sat_previdencia',
        'balcao_denatran',
        'balcao_correios',
        'balcao_nai_previdencia',
        'balcao_cadastro_presencial_govbr',
        'balcao_govbr',
        'bb_internet_banking',
        'banrisul_internet_banking',
        'bradesco_internet_banking',
        'caixa_internet_banking',
        'brb_internet_banking',
        'sicoob_internet_banking',
        'santander_internet_banking',
        'tse_facial',
        'certificado_digital'
      ],
      isGovAuthEnable: this.canalWebData.isGovAuthEnable
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
